module.exports = __webpack_public_path__ + "static/img/case.55c7522.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Conference/case.png
// module id = kZxJ
// module chunks = 1